import { Check, Users, ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";

const fmtCount = (n) => {
  if (!n || n < 1000) return n ? `${n}` : null;
  return `${(n / 1000).toFixed(n % 1000 === 0 ? 0 : 1)}k`;
};

const openGroup = (url) => {
  api.post("/public/fb-click").catch(() => {});
  window.open(url, "_blank", "noopener,noreferrer");
};

/* Full section — for Landing / Pricing. High-converting: social proof + benefits + single CTA. */
export function FacebookGroupCTA({ fb }) {
  if (!fb || !fb.enabled) return null;
  const count = fmtCount(fb.member_count);
  return (
    <section className="relative overflow-hidden border border-borderGold bg-surface/60 backdrop-blur-sm p-8 md:p-12" data-testid="fb-group-cta">
      <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-gold/5 blur-3xl pointer-events-none" />
      <div className="relative grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <div className="overline mb-3 flex items-center gap-2"><Users className="w-3 h-3" /> {fb.eyebrow}</div>
          <h2 className="font-display text-4xl md:text-5xl text-cream leading-[1.05]">{fb.headline}</h2>
          <p className="text-textMuted mt-4 leading-relaxed max-w-xl">{fb.subhead}</p>
          {count && (
            <div className="mt-5 flex items-center gap-2 text-sm font-mono text-gold">
              <Users className="w-4 h-4" /> {count} stewards already inside
            </div>
          )}
          <button data-testid="fb-group-join-main" onClick={() => openGroup(fb.url)} className="btn-gold mt-7">
            {fb.cta_label} <ArrowUpRight className="w-4 h-4" />
          </button>
          <p className="text-textDim text-xs font-mono mt-3 uppercase tracking-[0.2em]">Free forever · No card · Leave anytime</p>
        </div>
        <ul className="space-y-4">
          {(fb.benefits || []).map((b, i) => (
            <li key={i} className="flex gap-3 text-cream/90">
              <Check className="w-5 h-5 text-gold mt-0.5 shrink-0" /> <span>{b}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

/* Compact banner — for Blog index top. */
export function FacebookGroupBanner({ fb }) {
  if (!fb || !fb.enabled) return null;
  const count = fmtCount(fb.member_count);
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 border border-borderGold bg-surface/60 p-5" data-testid="fb-group-banner">
      <div className="flex items-center gap-3">
        <Users className="w-5 h-5 text-gold shrink-0" />
        <div>
          <div className="overline">{fb.eyebrow}</div>
          <div className="text-cream font-display text-xl leading-tight">{fb.name}{count ? ` · ${count} members` : ""}</div>
        </div>
      </div>
      <button data-testid="fb-group-join-banner" onClick={() => openGroup(fb.url)} className="btn-gold shrink-0">
        {fb.cta_label} <ArrowUpRight className="w-4 h-4" />
      </button>
    </div>
  );
}
